import styled from 'styled-components';

import { breakpoint } from '../Helper/Breakpoints';

export const ButtonBar = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;

  a,
  button {
    flex: 0 0 auto;
    align-self: center;
  }

  @media ${breakpoint.md} {
    flex-direction: row;
    justify-content: center;
  }
`;